import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { CountryService } from 'src/app/services/country.service';
import { BankService } from 'src/app/services/bank.service';
import { ContactService } from 'src/app/services/contact.service';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  styleUrls: ['./create-contact.component.scss']
})
export class CreateContactComponent implements OnInit {
  ng_first_name=""
  ng_last_name=""
  @Output("ContactCreated") contactCreated = new EventEmitter()
  selectedCountry
  countries=[]
  banks=[]
  branches:any=[]
  states=[]
  selected_bank_name
  machpay_branch_id
  bank_id
  india_bank_name
  transaction_type = 'Bank'
  providers = []
  bank_kes_select
  bank_kes_account
  bank_kes_confirm
  provider_select = ''
  bank_select = ''
  code_deposit
  provider_deposit
  errDeposit = ''
  bic_swift
  iban
  bank_name
  constructor(public auth:AuthService,public countryService:CountryService,public bankService:BankService,public contactService:ContactService,public router:Router,private messageService: MessageService,public common:CommonService) { }

  ngOnInit(): void {
    this.common.showLoader()
    this.countryService.getCountryList().subscribe((res:any)=>{
        this.countries=res.data.country_list
        this.common.stopLoader()
    })
  }

  createContact(contactForm:NgForm){
    let checkContact = true

    if(this.auth.user.country_id==39){
      

      contactForm.value.requestMoneyId=""
      // if(!contactForm.value.iban){
      //   contactForm.value.iban=""
      // }
      if(contactForm.value.payee_country==101){
        // console.log(contactForm.value.ifsc_code)
        contactForm.value.transaction_type = "Bank"
        if(!contactForm.value.ifsc_code){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter IFSC code!', summary: ''})
        }
        else if(!contactForm.value.account_number){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter account number!', summary: ''})
        }
        else if(!contactForm.value.confirm_account){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please confirm account number!', summary: ''})
        }
        else if(!contactForm.value.payee_address){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter address!', summary: ''})
        }
        else if(!contactForm.value.payee_street){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter street!', summary: ''})
        }
        else if(!contactForm.value.payee_city){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter recipient city!', summary: ''})
        }
        else if(!contactForm.value.payee_postalCode){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter recipient postal code!', summary: ''})
        }
        else if(!contactForm.value.payee_email){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter recipient email!', summary: ''})
        }
        contactForm.value.bank_name=this.india_bank_name
      }
      else{
        contactForm.value.transaction_type = this.transaction_type
        if(this.transaction_type == 'Bank' && (this.selectedCountry != 232 && this.selectedCountry != 15 && this.selectedCountry != 22 && this.selectedCountry != 57 && this.selectedCountry != 69 && this.selectedCountry != 74 && this.selectedCountry != 75 && this.selectedCountry != 82 && this.selectedCountry != 85 && this.selectedCountry != 105 && this.selectedCountry != 107 && this.selectedCountry != 120 && this.selectedCountry != 126 && this.selectedCountry != 127 && this.selectedCountry != 135 && this.selectedCountry != 145 && this.selectedCountry != 156 && this.selectedCountry != 177 && this.selectedCountry != 192 && this.selectedCountry != 200 && this.selectedCountry != 201 && this.selectedCountry != 207)){
          if(!contactForm.value.payee_address){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter address!', summary: ''})
          }
          else if(!contactForm.value.payee_street){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter street!', summary: ''})
          }
          else if(!contactForm.value.payee_city){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient city!', summary: ''})
          }
          else if(!contactForm.value.payee_postalCode){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient postal code!', summary: ''})
          }
          else if(!contactForm.value.payee_email){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient email!', summary: ''})
          }
          if(this.banks.find((element)=>{
            return contactForm.value.bank_name_id == element.code
          }))
          {
            if(!contactForm.value.account_number){
              checkContact = false
              this.messageService.add({severity:'error',detail : 'Please enter account number!', summary: ''})
            }
            contactForm.value.bank_name=this.banks.find((element)=>{
            return contactForm.value.bank_name_id == element.code
            }).name
          }
          else{
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please select bank!', summary: 'No bank selected'}) 
          }
        }
        else if(this.transaction_type == 'Bank'){
          if(!contactForm.value.bank_name){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient bank name!', summary: ''})
          }
          else if(!contactForm.value.payee_address){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter address!', summary: ''})
          }
          else if(!contactForm.value.payee_street){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter street!', summary: ''})
          }
          else if(!contactForm.value.payee_city){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient city!', summary: ''})
          }
          else if(!contactForm.value.payee_postalCode){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient postal code!', summary: ''})
          }
          else if(!contactForm.value.payee_email){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient email!', summary: ''})
          }
          else if(!this.iban){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter iban!', summary: ''}) 


          }
          else if(!this.bic_swift){
            checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter BIC Swift code!', summary: ''}) 


          }
          else if(!this.bank_name){
            checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter bank name!', summary: ''}) 


          }
        }
        else if(this.transaction_type == 'Mobile'){
          if(!contactForm.value.payee_address){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter address!', summary: ''})
          }
          else if(!contactForm.value.payee_street){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter street!', summary: ''})
          }
          else if(!contactForm.value.payee_city){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient city!', summary: ''})
          }
          else if(!contactForm.value.payee_postalCode){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient postal code!', summary: ''})
          }
          else if(!contactForm.value.payee_email){
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please enter recipient email!', summary: ''})
          }
          if( this.providers.find((element)=>{
            return contactForm.value.mobile_provider_code == element.code
          }))
          {
            if(!contactForm.value.deposit_number){
              checkContact = false
              this.messageService.add({severity:'error',detail : 'Please enter deposit number!', summary: 'Deposit number not entered!'})
            }
            else{
              contactForm.value.mobile_provider_name=this.providers.find((element)=>{
              return contactForm.value.mobile_provider_code == element.code
              }).name
              contactForm.value.deposit_code = this.code_deposit || '0'
              contactForm.value.payee_contact = contactForm.value.deposit_number
            }
            
          }
          else{
            checkContact = false
            this.messageService.add({severity:'error',detail : 'Please select provider!', summary: 'No provider selected'}) 
          }
        }
        
      }
      this.common.showLoader()
      if(checkContact){
        this.contactService.createContact(contactForm.value).subscribe(res=>{
          this.contactCreated.emit(true)
          this.providers = []
          this.code_deposit = ''
          this.selectedCountry = ''
          document.querySelector('#collapseOne').classList.remove('show')
          contactForm.resetForm()
          this.common.stopLoader()
        },err=>{
          let errorKeys = Object.keys(err.error.errors);
          errorKeys.forEach(key => {
            //console.log(key)
            let value = err.error.errors[key][0];
            this.messageService.add({severity:'error', summary:value, detail:""});
            //console.log(value);
        });
        //console.log(err)
        this.common.stopLoader()
        })
      }
      this.common.stopLoader()
      
    }
    else{
     if(!contactForm.value.address_line1){
        checkContact = false
        this.messageService.add({severity:'error',detail : 'Please enter address!', summary: ''})
      }
      else if(!contactForm.value.address_line2){
        checkContact = false
        this.messageService.add({severity:'error',detail : 'Please enter street!', summary: ''})
      }
      //console.log(contactForm.value)
      if(contactForm.value.country_id==101){
        if(!contactForm.value.ifsc_code){
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please enter IFSC code!', summary: ''})
        }
        contactForm.value.bank_name=this.india_bank_name
        contactForm.value.branch_id=this.machpay_branch_id
        contactForm.value.bank_id=this.bank_id
      }
      if(this.transaction_type == 'Mobile'){
        if( this.providers.find((element)=>{
          return contactForm.value.mobile_provider_code == element.code
        }))
        {
          contactForm.value.mobile_provider_name=this.providers.find((element)=>{
          return contactForm.value.mobile_provider_code == element.code
          }).name
        }
        else{
          checkContact = false
          this.messageService.add({severity:'error',detail : 'Please select provider!', summary: 'No provider selected'}) 
        }
      
      }
      contactForm.value.home_phone=""
      contactForm.value.mobile_phone=""
      contactForm.value.work_phone=""
      contactForm.value.date_of_birth=""
      contactForm.value.occupation=""
      contactForm.value.branch_location=""
      contactForm.value.transaction_type = this.transaction_type
      this.common.showLoader()
      if(checkContact){
        this.contactService.createContact(contactForm.value).subscribe(res=>{
          //console.log(res)
          this.contactCreated.emit(true)
          document.querySelector('#collapseOne1').classList.remove('show')
          contactForm.resetForm()
          this.common.stopLoader()
        },err=>{
          let errorKeys = Object.keys(err.error.errors);
        errorKeys.forEach(key => {
          //console.log(key)
          let value = err.error.errors[key][0];
          this.messageService.add({severity:'error', summary:value, detail:""});
          //console.log(value);
      });
        //console.log(err)
        this.common.stopLoader()
        })
      }
      this.common.stopLoader()
      
    }
  }

  onCountryChange(countryId){
    this.selectedCountry = countryId
    this.banks = []
    this.providers = []
    this.common.showLoader()
    if(this.selectedCountry==35 || this.selectedCountry==93 || this.selectedCountry==160 || this.selectedCountry==220 || this.selectedCountry==54 || this.selectedCountry==134 || this.selectedCountry==183 || this.selectedCountry==50 || this.selectedCountry==38 || this.selectedCountry==229){
      //only mobile money countries -> Burkina faro || Guinnea bissau || Niger || Togo || Ivory Coast || Mali || Uganda || Rwanda || Cameroon || Congo
      let country = this.countries.find(obj => obj.id == this.selectedCountry )
      this.transaction_type = "Mobile"
      this.contactService.getProviders(country.currency.toLowerCase(), country.iso2).subscribe((res:any) => {
        this.providers = res.data['providers']
        this.code_deposit = res.data['country_code'] ? res.data['country_code'] : country.phonecode
        this.common.stopLoader()
      }, err => {
        this.common.stopLoader()
      })
    }
    else if(this.selectedCountry==24 || this.selectedCountry==195 || this.selectedCountry==83 || this.selectedCountry==113 || this.selectedCountry==204 || this.selectedCountry==174 || this.selectedCountry == 161 || this.selectedCountry == 101 || this.selectedCountry == 45 || this.selectedCountry == 199 || this.selectedCountry == 102 || this.selectedCountry == 240){
      //fetch bank list for benin || senegal || kenya || south africa || ghana || philippines || nigeria || india || china || vietnam || singapore || indonesia
      this.transaction_type = "Bank"
      this.bankService.getBankList(countryId).subscribe((res:any)=>{
        if(res.return)
        {
          this.banks=res.data.bank_list
          this.states=res.data.state_list
        }
        else{
          this.messageService.add({severity:'error', summary:'Something went wrong'});
        }
        this.common.stopLoader()
      },err=>{
        let errorKeys = Object.keys(err.error.errors);
        errorKeys.forEach(key => {
          let value = err.error.errors[key][0];
          this.messageService.add({severity:'error', summary:value, detail:""});
        });
        this.common.stopLoader()
      })
      if(this.selectedCountry==24 || this.selectedCountry==195 || this.selectedCountry==83 || this.selectedCountry==113 || this.selectedCountry==161){
        // get mobile providers for benin, senegal, ghana, kenya, nigeria
        let country = this.countries.find(obj => obj.id == this.selectedCountry )
        this.contactService.getProviders(country.currency.toLowerCase(), country.iso2).subscribe((res:any) => {
        this.providers = res.data['providers']
        this.code_deposit = res.data['country_code'] ? res.data['country_code'] : country.phonecode
        console.log(this.code_deposit)
        this.common.stopLoader()
      }, err => {
        this.common.stopLoader()
      })
      }
    }
    else{
      //no action in case of eur countries, india, united kingdom
      this.transaction_type = "Bank"
      this.common.stopLoader()
    }
      
    
  }

  verifyIFSC(ifsc){
    this.common.showLoader()
    this.contactService.getBankName(ifsc).subscribe((res:any)=>{
      if(res.return){
        if(this.auth.user.country_id==39){
          this.india_bank_name = res.data.BANK
        }
        else{
          this.india_bank_name=res.data.response.name
          this.machpay_branch_id = res.data.response.machpay_branch_id
          this.bank_id = res.data.response.id
        }
      }
      else{
        this.india_bank_name=""
        this.machpay_branch_id=""
        this.bank_id=""
        this.messageService.add({severity:'error', summary:"Please enter correct IFSC and try again", detail:""});
      }
      this.common.stopLoader()
    },err => {
      this.common.stopLoader()
      this.messageService.add({severity:'error', summary:"Please enter correct IFSC and try again", detail:""});
    })
  }

  onBankChange(bankID){
    this.common.showLoader()
    this.contactService.getBranch(bankID).subscribe(res=>{
      this.branches=res
      this.common.stopLoader()
    })
    
  }


  VerifyAccountNumber(bankcode,ngaccountnumber){
    this.common.showLoader()
    this.contactService.getName(bankcode,ngaccountnumber).subscribe((res:any)=>{
     if(res.result || res.return){
      if(this.auth.user.country_id==233){
        this.ng_first_name = res.name.split(" ")[0]
        this.ng_last_name = res.name.split(" ")[1]
      }else{
        this.ng_first_name=res.data
      }
     }
     else{
      this.messageService.add({severity:'success', summary:res.message, detail:""});
     }
      this.common.stopLoader()
    },err=>{
      this.ng_last_name=""
      this.ng_first_name=""
      this.common.stopLoader()
    })
  }


  changeType(type, currency){
    this.common.showLoader()
    this.transaction_type = type
    if(type=="Mobile"){
      this.common.stopLoader()
      this.bank_kes_select = ''
      this.bank_kes_account = ''
      this.bank_kes_confirm = ''
    }
    else{
      this.common.stopLoader()
    }
      

  }

  checkDeposit(){
    this.errDeposit = ''
    if(this.provider_deposit.length>9){
      this.errDeposit = 'Maximum length of deposit number is 9.'
    }
  }

  convertToUpper(event){
    // console.log(event.target.value)
    event.target.value = event.target.value.toUpperCase()
  }

}
